


















































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useUserStore } from "@/shared/store/user";
import { useThemeStore } from "@/shared/store/theme";
import {
    CardProviderCapability,
    DebitCardManagerModalViewState,
    DebitCardRecord,
    CardStatus,
    PotentialCardHolder,
    DependentRequest,
    FetchState
} from "@/shared/types";

@Component({
    components: {}
})
export default class RequestNewCardForm extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    contactInfoStore = useContactInfoStore();
    userStore = useUserStore();
    themeStore = useThemeStore();
    DebitCardManagerModalViewState = DebitCardManagerModalViewState;
    selected: null|number = null;

    get submitDisabled () {
        return this.selected === null || ! this.isMailingAddressPresentOrLoading;
    }

    get primaryAccountHolderName () {
        return `${this.userStore.user.firstName} ${this.userStore.user.lastName}`;
    }

    get isMailingAddressPresentOrLoading () {
        return this.contactInfoStore.contactInformationState !== FetchState.Loaded ||
            this.debitCardManagementStore.mailingAddress !== null;
    }

    getPotentialCardHolderName (x: PotentialCardHolder) {
        return `${x.firstName} ${x.lastName}`;
    }

    get secondaryPotentialCardHolders () {
    return this.debitCardManagementStore.potentialCardHolders.sort((a, b) => {
        if (a.firstName.toLowerCase() === b.firstName.toLowerCase()) {
          return a.lastName.toLowerCase().localeCompare(b.lastName.toLowerCase());
        }
        return a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase());
      });
    }

    mounted () {
        this.contactInfoStore.getContactInformation();
    }

    onSubmitChanges (e: Event) {
        e.preventDefault();
        if (this.selected < 0) {
            this.debitCardManagementStore.setPotentialNewCardHolder(null);
        } else {
            const selectedDependent = this.debitCardManagementStore.potentialCardHolders[this.selected];
            this.debitCardManagementStore.setPotentialNewCardHolder(selectedDependent);
        }

        this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.RequestNewCardConfirmForm);
    }
}
